module.exports = __webpack_public_path__ + "static/media/after_ragby.c11816ef.mp3";